import { IListOptionsFilter, defaultListOptionsFilter } from "./list-options-filter";

export interface IQueryStringFilter extends IListOptionsFilter {
    queryString?: string;
}

export const defaultQueryStringFilter = {
  ...defaultListOptionsFilter,
  queryString: ''
}
